export const styles = {
	ActionLink: {
		':hover': { backgroundColor: 'transparent' },
		color: 'secondary.main',
		flexGrow: 1,
		flexShrink: 0,
		fontWeight: 700,
		padding: 0,
		fontSize: { xs: '1.2rem', lg: '1.4rem' },
	},
	CopyrightContainer: {
		alignItems: { xs: 'center', sm: 'start', md: 'center' },
		display: 'flex',
		flexDirection: 'column',
		justifySelf: { sm: 'start', md: 'auto' },
		marginBottom: { xs: '1rem', sm: 0 },
	},
	CopyrightInnerGrid: {
		display: 'block',
		alignItems: 'center',
		textAlign: 'center',
	},
	FooterContainer: {
		backgroundColor: '#F5F5F5;',
		color: 'text.secondary',
		justifyContent: {
			xs: 'center',
			sm: 'space-between',
			md: 'space-between',
		},
		alignItems: 'center',
		paddingBottom: '2rem',
		paddingTop: '2rem',
		paddingLeft: '3.2rem',
		paddingRight: '3.2rem',
		zIndex: 2,
	},
	LogoImages: {
		marginLeft: '1rem',
		flexDirection: 'column',
	},
	LogosContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'end',
		justifySelf: { sm: 'end', md: 'auto' },
	},
	responsiveTextSize: {
		fontSize: {
			lg: '1.4rem',
			xs: '1.2rem',
		},
	},
	platformTypography: {
		fontSize: { xs: '1.2rem', lg: '1.4rem' },
	},
	CenterSectionContainer: {
		justifyItems: 'center',
		maxWidth: 'fit-content !important',
		Button: {
			fontSize: '1.5rem',
		},
	},
	CenterSectionContainerAlternative: {
		justifyItems: { xs: 'center', sm: 'start', md: 'center' },
		maxWidth: 'fit-content !important',
		Button: {
			fontSize: '1.5rem',
		},
	},
	centerSectionGrid: {
		width: '100%',
		display: 'contents',
		spacing: { xs: 1, md: 2 },
	},
}
